<div class="container-fluid">
  <app-header titleText="Dealer Contacts" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null">
    <h5 i18n>Please provide report criteria</h5>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
          <ng-template [ngIf]="dealer"><span i18n>Dealer:</span> {{dealer.dealer_BusinessName}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>Contacts</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Dealer</th>
                <th i18n>Region</th>
                <th i18n>Created</th>
                <th i18n>User Name</th>
                <th i18n>User Role</th>
                <th i18n>User Email</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dealer of report">
                <td>{{dealer.dealer_BusinessName}}</td>
                <td>{{dealer.dealer_RegionName}}</td>
                <td>{{dealer.dealer_Created | date : 'M/d/yyyy'}}</td>
                <td>{{dealer.userName}}</td>
                <td>{{dealer.userRole}}</td>
                <td>{{dealer.userEmail}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
